export enum PortalMode {
  Default,
  Borgenar,
  Norge
}
